import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

function guardHistoryStateMethods(): void {
  const wrap = (method: 'pushState' | 'replaceState') => {
    const original = window.history[method].bind(window.history);
    window.history[method] = ((...args: Parameters<History['pushState']>) => {
      try {
        return original(...args);
      } catch (error) {
        // Some mobile browser integrations/extensions patch history and may throw on dispatchEvent(null).
        console.warn(`[history.${method}] ignored runtime error`, error);
        return;
      }
    }) as History['pushState'];
  };

  wrap('pushState');
  wrap('replaceState');
}

guardHistoryStateMethods();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
